export default "__VITE_ASSET__DOBm9D2s__"